// src/pages/care/complianceEvidenceRegistry.js
export const COMPLIANCE_EVIDENCE_TYPES = {
  WA_AFH_075_HOT_WATER_TEMPERATURE: {
    label: "Hot Water Temperature Reading",
    apiModule: "waterTemperatureReadings", // careService.waterTemperatureReadings
    fields: [
      {
        name: "readingDateTime",
        label: "Date and time",
        type: "datetime",
        required: true,
      },
      {
        name: "location",
        label: "Location",
        type: "select",
        options: [
          ["RESIDENT_BATHROOM", "Resident bathroom"],
          ["KITCHEN_SINK", "Kitchen sink"],
          ["LAUNDRY", "Laundry"],
          ["OTHER", "Other"],
        ],
      },
      {
        name: "temperatureFahrenheit",
        label: "Temperature (°F)",
        type: "number",
        step: "0.1",
        required: true,
      },
      { name: "reportAttachments", label: "Photo evidence", type: "photo" },
      { name: "issuesFound", label: "Issues found", type: "textarea" },
      {
        name: "correctiveActions",
        label: "Corrective actions",
        type: "textarea",
      },
      { name: "notes", label: "Notes", type: "textarea" },
    ],
  },
  WA_AFH_003_ANNUAL_LICENSE_FEE: {
    label: "Annual License Fee Payment",
    apiModule: "workspaceLicenseRecords",
    fields: [
      { name: "licenseNumber", label: "License number", type: "text" },
      { name: "licensedBedCount", label: "Licensed bed count", type: "number" },
      {
        name: "feeAmount",
        label: "Fee amount ($)",
        type: "number",
        step: "0.01",
      },
      {
        name: "expirationDate",
        label: "License expiration date",
        type: "date",
        required: true,
      },
      { name: "paidDate", label: "Date paid", type: "date" },
      {
        name: "paidAmount",
        label: "Amount paid ($)",
        type: "number",
        step: "0.01",
      },
      {
        name: "confirmationNumber",
        label: "Confirmation number",
        type: "text",
      },
      {
        name: "paymentMethod",
        label: "Payment method",
        type: "select",
        options: [
          ["CHECK", "Check"],
          ["ONLINE_DSHS_PORTAL", "Online DSHS portal"],
          ["MONEY_ORDER", "Money order"],
          ["OTHER", "Other"],
        ],
      },
      { name: "proofOfPayment", label: "Proof of Payment", type: "photo" },
      { name: "notes", label: "Notes", type: "textarea" },
    ],
  },
};
